<div class="enter-voucher-code d-flex flex-column justify-content-between h-100">
    <div>
        <div class="p-4">
            <div class="back-link d-flex justify-content-start align-items-center cursor-pointer" (click)="cancel()">
                <mat-icon fontIcon="arrow_back"></mat-icon>
                <span>back</span>
            </div>
            <h2 class="title mt-4 mb-2">Cash Out via Voucher Code</h2>
            <p class="sub-text">Ask the customer for the 9-digit code shown in their app, then redeem the voucher and pay out the cash from your counter.</p>
        </div>

        <div class="px-4">
            <div class="voucher-code-boxes" [class.has-error]="!!errorBanner">
                <app-value-field-otp [size]="voucherCodeLength" [formControl]="voucherCodeControl"></app-value-field-otp>
            </div>

            <button mat-stroked-button color="primary" class="rounded-pill clear-all-btn mt-3" *ngIf="voucherCodeControl.value && !errorBanner" (click)="clearAll()">
                Clear All
            </button>

            <div class="error-banner mt-4" *ngIf="errorBanner">
                <div class="icon">
                    <mat-icon fontIcon="close" style="font-size: 20px"></mat-icon>
                </div>
                <div class="content">
                    <div class="title">{{ errorBanner.title }}</div>
                    <div class="message">{{ errorBanner.message }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer-bar">
        <div class="d-flex gap-2">
            <button mat-flat-button color="primary" class="rounded-pill continue-btn" [disabled]="!isCodeComplete || loading || !!errorBanner" (click)="continue()">
                Continue
            </button>
            <button mat-stroked-button color="primary" class="rounded-pill cancel-btn" (click)="cancel()">Cancel</button>
        </div>
        <!-- Once an error banner is shown, Figma moves Clear All from the button below the boxes
             into the footer as a plain text link (node 8456:124514) — the slot below the boxes is
             taken by the error banner instead. -->
        <button type="button" class="clear-all-link" *ngIf="errorBanner" (click)="clearAll()">Clear All</button>
    </div>

    <div class="loading-overlay" *ngIf="loading">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
</div>
